<template>
	<v-menu
		open-on-hover
		top
		offset-y
	>
		<template v-slot:activator="{ on, attrs }">
			<span @click="goToProfile()" v-if="user" class="hover-content" :class="hoverClass"
				v-bind="attrs"
				v-on="on"
			>
				<template class="d-flex flex-row align-items-center">
					<template v-if="avatar">
						<avatar :user="user" :xs="xs" :sm="sm" :bg="bg" :xxl="xxl" :class="{'mr-1' : userName, avatarClass}"/>
					</template>
					<div v-if="!avatar || userName">
						{{ user.name || user.email }}
					</div>
				</template>
			</span>
		</template>
		<v-card v-if="user">
			<v-card-text>
				<div class="d-flex flex-row align-items-center">
					<avatar :user="user" />
					<div class="ml-1 my-auto">
						<div class="bold">{{ user.name || user.email }}</div>
						{{ user.job_position }}
					</div>
				</div>
				<div class="mt-3">
					<v-btn @click="goToProfile()" color="accent" elevation="0" small>Przejdź do profilu</v-btn>
				</div>

			</v-card-text>
		</v-card>
    </v-menu>
</template>

<script>
import Avatar from '@/components/Avatar'
export default {
	components: {
		Avatar
	},
	props: {
		hoverClass: {
			type: String
		},
		user: {
			type: Object
		},
		prependAt: {
			type: Boolean,
			default: false
		},
		avatar: {
			type: Boolean,
			default: false
		},
		xs: {
			type: Boolean,
			default: false,
		},
		sm: {
			type: Boolean,
			default: false,
		},
		bg: {
			type: Boolean,
			default: false,
		},
		xxl: {
			type: Boolean,
			default: false
		},
		userName: {
			type: Boolean,
			default: false
		},
		avatarClass: {
			type: String,
			default: ''
		}
	},
	methods: {
		goToProfile() {
			this.$router
				.push({
					name: "Profile",
					params: { userID: this.user.id },
				})
				.catch(() => {});
			this.$emit('goTo')
		}
	}
}
</script>

<style lang="scss" scoped>
	.hover-content {
		cursor: pointer;
	}
</style>
